module.exports = __webpack_public_path__ + "static/img/news3.4f1eab3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news1/news3.png
// module id = 4v2O
// module chunks = 1